import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { take } from 'rxjs/operators';
import { ApiService } from 'src/app/services/api/api.service';
import { ToastService } from 'src/app/services/toast/toast.service';
import { StorageService } from 'src/app/services/azure/storage/storage.service';
import { Router } from '@angular/router';
import { Subscription } from '../settings/components/monetization/components/membership/membership.model';
import { AppBLL } from 'src/app/app.bll';
@Injectable({
  providedIn: 'root',
})
export class BusContactsBLL {
  //#region Loaders Observables

  private isLoading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false
  );
  readonly isLoading$: Observable<boolean> = this.isLoading.asObservable();

  private isAddContactModelOpen: BehaviorSubject<boolean> =
    new BehaviorSubject<boolean>(false);
  readonly isAddContactModelOpen$: Observable<boolean> =
    this.isAddContactModelOpen.asObservable();

  private isUpdateContactModelOpen: BehaviorSubject<boolean> =
    new BehaviorSubject<boolean>(false);
  readonly isUpdateContactModelOpen$: Observable<boolean> =
    this.isUpdateContactModelOpen.asObservable();


  private contacts: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  readonly contacts$: Observable<any> = this.contacts.asObservable();


  private contact: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  readonly contact$: Observable<any> = this.contact.asObservable();

  private creation_status: BehaviorSubject<string> =
    new BehaviorSubject<string>(null);
  readonly creation_status$: Observable<string> =
    this.creation_status.asObservable();

  selectedContact$: Subject<any> = new Subject<any>();
  selectedBuses$: Subject<any> = new Subject<any>();

  //#endregion Data Observables

  constructor(
    private api: ApiService,
    private toast: ToastService,
    private appBll: AppBLL
  ) { }

  public getContacts(admin_id: string = null) {
    this.isLoading.next(true);

    let url = `field-events?type=get_all_bus_contacts`;

    if (admin_id) {
      url += `&admin_id=${admin_id}`;
    }


    this.api
      .get(url)
      .pipe(take(1))
      .subscribe(
        (response: any) => {
          this.contacts.next(response);
          this.isLoading.next(false);
        },
        (err) => {
          this.isLoading.next(false);
        }
      );
  }

  public getContact() {
    this.isLoading.next(true);

    let url = `field-events?type=get_bus_contact`;

    this.api
      .get(url)
      .pipe(take(1))
      .subscribe(
        (response: any) => {
          this.contact.next(response);
          this.isLoading.next(false);
        },
        (err) => {
          this.isLoading.next(false);
        }
      );
  }

  public getContactsById(id) {
    this.isLoading.next(true);

    let url = `field-events?type=get_all_bus_contacts`;

    this.api
      .get(url)
      .pipe(take(1))
      .subscribe(
        (response: any) => {
          this.contacts.next(response);
          this.isLoading.next(false);
          this.selectedBuses$.next(id);
        },
        (err) => {
          this.isLoading.next(false);
        }
      );
  }


  public async createContact(contact, admin_id: string = null) {
    this.isLoading.next(true);

    let url = `field-events?type=post_bus_contact`;

    if (admin_id) {
      url += `&admin_id=${admin_id}`;
    }

    this.api
      .post(url, contact)
      .pipe(take(1))
      .subscribe(
        (response: any) => {
          this.isLoading.next(false);
          this.creation_status.next('success');
          this.selectedBuses$.next(response.data.id);
          this.toast.showToast('Success!', 'Contact has been created.');
          this.toggleAddContactModel(false);
        },
        (err) => {
          this.isLoading.next(false);
        }
      );
  }



  public async deleteContact(id: string, admin_id: string = null) {
    let url = `field-events?type=delete_bus_contact&id=${id}`;

    if (admin_id) {
      url += `&admin_id=${admin_id}`;
    }

    this.api.delete(url).subscribe(
      async () => {
        this.getContacts(admin_id);
        this.toast.showToast('Success!', 'Contact has been deleted.');
      },
      async (err) => {
        console.log('HTTP Error', err);
      }
    );
  }

  public async editContact(id, contact, admin_id: string = null) {
    let url = `field-events?type=update_bus_contact`;

    if (admin_id) {
      url += `&admin_id=${admin_id}`;
    }

    this.isLoading.next(true);

    let update_contact = { ...contact, id: id };

    this.api
      .patch(url, update_contact)
      .pipe(take(1))
      .subscribe(
        (response: any) => {
          this.isLoading.next(false);
          this.toast.showToast('Success!', 'Contact has been updated.');
          this.creation_status.next('success');
        },
        (err) => {
          this.isLoading.next(false);
        }
      );
  }



  toggleAddContactModel(isOpen: boolean) {
    this.isAddContactModelOpen.next(isOpen);
  }

  changeUpdateContactModelOpen(isOpen: boolean) {
    this.isUpdateContactModelOpen.next(isOpen);
  }

}
